import { getDownloadURL, getStorage, ref, uploadBytesResumable } from "firebase/storage";
import { useCallback, useState } from "react";
import app from "../config/firebase";
import { MAX_FILE_SIZE_MB } from "../constants/commonConstants";

const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert MB to bytes

const useFirebaseFileUpload = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadFilesToFirebase = useCallback(
    async (uploadedFiles, folderName) => {
      setIsLoading(true);
      setError(null);
      try {
  
        //checking for large files
        for (const file of uploadedFiles) {
          if (file.size > MAX_FILE_SIZE_BYTES) {
            throw new Error(`Some files exceed the 20 MB size limit.`, {cause: "logical"});
          }
        }

        const storage = getStorage(app);
        const uploadedUrls = await Promise.all(
          uploadedFiles.map((file) => {
            return new Promise((resolve, reject) => {
              const fileName = new Date().getTime() + "__" + file.name;
              const storageRef = ref(storage, `${folderName}/${fileName}`);
              const uploadTask = uploadBytesResumable(storageRef, file);
              uploadTask.on(
                "stage_changed",
                null,
                (error) => reject(error),
                async () => {
                  try {
                    const downloadURL = await getDownloadURL(
                      uploadTask.snapshot.ref
                    );
                    resolve(downloadURL);
                  } catch (urlError) {
                    reject(urlError);
                  }
                }
              );
            });
          })
        );
        return { success: true, uploadedUrls };
      } catch (uploadError) {
        const error = {
          success: false,
          message: "File Uploading Error"
        };

        if(uploadError?.cause === "logical"){
          error.message = uploadError?.message;
        }
        
        setError({success: false, error: error});
        
        return ({success: false, error: error});

      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return [ uploadFilesToFirebase, isLoading, error ];
};

export default useFirebaseFileUpload;